import { Status } from '@philo/web-shared';
import { isTouchDevice } from '../../utils/device';
import {
  getStripePaymentReady,
  getSubscriptionCode,
  getSubscriptionCodeValid,
} from '../../web-shared/redux/selectors/shared-billing';
import { RootState } from '../reducers';
import { getIsRegistering, getNormalizedIdent } from './authProgress';
import { getHasAgreedToPaymentTerms, getIsSignupInfoComplete } from './billing';
import { getIsActivatingDevice } from './device-auth';

export function getIsSendingAuthRequest({ auth }: RootState) {
  return auth.isSendingAuthRequest;
}

export function getIsAuthRequestFailed({ auth }: RootState) {
  return auth.isAuthRequestFailed;
}

export function getIsPossibleLoginAttempt({ auth }: RootState) {
  return auth.isPossibleLoginAttempt;
}

export function getAuthMessage({ auth }: RootState) {
  return auth.message;
}

export function getErrorCode({ auth }: RootState) {
  return auth.errorCode;
}

export function getIsAuthRestartRequired({ auth }: RootState) {
  return auth.isAuthRestartRequired;
}

export function getIsUserInPhiloSupportedGeoRegion({ auth }: RootState) {
  return auth.isUserInPhiloSupportedGeoRegion;
}

export function getUserLocation({ auth }: RootState) {
  return auth.location;
}

export function getInputStatus({ auth }: RootState) {
  return auth.inputStatus;
}

export function getInputFocused({ auth }: RootState) {
  return auth.inputFocused;
}

export function getZipInputStatus({ auth }: RootState) {
  return auth.zipInputStatus;
}

export function getAllInputsValid(state: RootState) {
  const subscriptionCode = getSubscriptionCode(state);
  const subscriptionCodeValid = getSubscriptionCodeValid(state);
  const validInput = getInputStatus(state) === Status.VALID;

  return validInput && (!subscriptionCode || subscriptionCodeValid);
}

export function getIsSubmitEnabled(state: RootState) {
  const signupInfoComplete = getIsSignupInfoComplete(state);
  const stripePaymentReady = getStripePaymentReady(state);
  const hasAgreedToPaymentTerms = getHasAgreedToPaymentTerms(state);

  return signupInfoComplete && stripePaymentReady && hasAgreedToPaymentTerms;
}

export function getAuthCode({ auth }: RootState) {
  return auth.authCode;
}

export function getAuthCodeStatus({ auth }: RootState) {
  return auth.authCodeStatus;
}

export function getIncludeEmailLink(state: RootState) {
  return !getIsActivatingDevice(state);
}

export function getShouldRequestAuthNewCode({ auth }: RootState) {
  return auth.shouldRequestAuthNewCode;
}

export function getAuthCodeActionURL(state: RootState) {
  const isRegistering = getIsRegistering(state);
  return state.authConfig[isRegistering ? 'registerActionURL' : 'loginActionURL'];
}

export function getAuthCodeRequestOptions(state: RootState) {
  const { device, config } = state;
  const includeEmailLink = getIncludeEmailLink(state);
  const location = getUserLocation(state);
  const ident = getNormalizedIdent(state);
  return {
    device_ident: device.ident,
    device: device.type,
    ident,
    include_login_link: includeEmailLink,
    send_confirm_link: includeEmailLink && !isTouchDevice(),
    location,
    send_token: config.sendToken,
  };
}
